import { OutlinedInputClassKey, StyleRules } from '@material-ui/core';

const MuiOutlinedInput: Partial<StyleRules<OutlinedInputClassKey, {}>> = {
  root: {
    borderRadius: '6px',
    // Guinda para el feedback de validacion (--ds-color-error-700), igual que en
    // el Input del Design System.
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--ds-color-error-700)',
    },
  },
};

export default MuiOutlinedInput;
